module.exports = __webpack_public_path__ + "img/Greece.ae2b81c8.svg";